import api, { API_BASE_URL } from './api';

const BASE_URL = '/admin/support-chat/sessions';
const KNOWLEDGE_URL = '/admin/support-chat/knowledge';

const buildWebSocketBaseUrl = () => {
  const parsedUrl = new URL(API_BASE_URL);
  const protocol = parsedUrl.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${parsedUrl.host}`;
};

const supportChatService = {
  listSessions: async (params = {}) => {
    const response = await api.get(`${BASE_URL}/`, { params });
    return response.data;
  },

  getSession: async (id) => {
    const response = await api.get(`${BASE_URL}/${id}/`);
    return response.data;
  },

  updateSession: async (id, data) => {
    const response = await api.patch(`${BASE_URL}/${id}/`, data);
    return response.data;
  },

  sendMessage: async (id, data) => {
    const { attachment, ...messageData } = data || {};

    if (attachment) {
      const formData = new FormData();
      formData.append('content', messageData.content || '');
      formData.append('message_type', messageData.message_type || 'attachment');
      formData.append('attachment', attachment);

      const response = await api.post(`${BASE_URL}/${id}/messages/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    }

    const response = await api.post(`${BASE_URL}/${id}/messages/`, messageData);
    return response.data;
  },

  closeSession: async (id) => {
    const response = await api.post(`${BASE_URL}/${id}/close/`);
    return response.data;
  },

  takeOverSession: async (id) => {
    const response = await api.post(`${BASE_URL}/${id}/take-over/`);
    return response.data;
  },

  setRetentionHold: async (id, data) => {
    const response = await api.post(`${BASE_URL}/${id}/retention-hold/`, data);
    return response.data;
  },

  listAgentRatings: async (params = {}) => {
    const response = await api.get('/admin/support-chat/agent-ratings/', { params });
    return response.data;
  },

  listNotifications: async (params = {}) => {
    const response = await api.get('/admin/support-chat/notifications/', { params });
    return response.data;
  },

  getUnreadNotificationCount: async () => {
    const response = await api.get('/admin/support-chat/notifications/unread-count/');
    return response.data;
  },

  markNotificationRead: async (id) => {
    const response = await api.post(`/admin/support-chat/notifications/${id}/read/`);
    return response.data;
  },

  markSessionNotificationsRead: async (id) => {
    const response = await api.post(`${BASE_URL}/${id}/notifications/read/`);
    return response.data;
  },

  getAvailabilitySettings: async () => {
    const response = await api.get('/admin/support-chat/availability/');
    return response.data;
  },

  updateAvailabilitySettings: async (data) => {
    const response = await api.patch('/admin/support-chat/availability/', data);
    return response.data;
  },

  buildSessionWebSocketUrl: (id) => {
    const token = localStorage.getItem('token');
    const query = token ? `?token=${encodeURIComponent(token)}` : '';
    return `${buildWebSocketBaseUrl()}/ws/support-chat/sessions/${id}/${query}`;
  },

  listKnowledge: async (params = {}) => {
    const response = await api.get(`${KNOWLEDGE_URL}/`, { params });
    return response.data;
  },

  getKnowledge: async (id) => {
    const response = await api.get(`${KNOWLEDGE_URL}/${id}/`);
    return response.data;
  },

  createKnowledge: async (data) => {
    const response = await api.post(`${KNOWLEDGE_URL}/`, data);
    return response.data;
  },

  updateKnowledge: async (id, data) => {
    const response = await api.patch(`${KNOWLEDGE_URL}/${id}/`, data);
    return response.data;
  },

  deleteKnowledge: async (id) => {
    const response = await api.delete(`${KNOWLEDGE_URL}/${id}/`);
    return response.data;
  },
};

export default supportChatService;
